/**
 * Extras section — penalty, reminder.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

interface HabitFormExtrasProps {
  penalty: string
  isReminderEnabled: boolean
  onPenaltyChange: (v: string) => void
  onReminderChange: (v: boolean) => void
}

export const HabitFormExtras: React.FC<HabitFormExtrasProps> = ({
  penalty, isReminderEnabled, onPenaltyChange, onReminderChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {/* Penalty text */}
      <div>
        <label className="block text-xs font-medium text-text-hint mb-1">
          {t('home.habitForm.penalty')}
        </label>
        <input type="text" value={penalty}
          onChange={(e) => onPenaltyChange(e.target.value)}
          className="w-full h-10 bg-white/5 border border-border rounded-xl px-3 text-sm text-text outline-none focus:ring-2 focus:ring-primary"
          placeholder={t('home.habitForm.penaltyPlaceholder')} />
      </div>

      {/* Reminder toggle */}
      <div className="flex items-center justify-between">
        <span className="text-sm text-text">{t('home.habitForm.reminder')}</span>
        <button type="button" onClick={() => onReminderChange(!isReminderEnabled)}
          className={`w-11 h-6 rounded-full transition-colors relative ${
            isReminderEnabled ? 'bg-primary' : 'bg-white/10'
          }`}>
          <div className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-transform ${
            isReminderEnabled ? 'translate-x-[22px]' : 'translate-x-0.5'
          }`} />
        </button>
      </div>
    </>
  )
}
